import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {defineMessages, injectIntl} from 'react-intl';
import {LocalStorage, Analytics} from '../../../shared';

import Background from '../../Atoms/Background';
import Logo from '../../Atoms/Logo';
import Text from '../../Atoms/Text';
import Button from '../../Atoms/Button';
import Link from '../../Atoms/Link';
import Card from '../../Atoms/Card';
import Helmet from '../../Organisms/Helmet';
import SendPhotoForm from '../../Organisms/SendPhotoForm';
import Grid from '../../Molecules/Grid';
import LanguageChooser from '../../Molecules/LanguageChooser';
import CardForm from '../../Molecules/CardForm';
import GetCustomerForm from '../../Molecules/GetCustomerForm';
import ErrorModal from '../../Molecules/ErrorModal';
import FacialIcon from '../../../assets/images/face_recognition.png';
import FacialModal from '../../Organisms/FacialModal';

import {fetchCard, fetchCardCustomer,clearMedias, clearCard, fetchMedias} from '../../../store/actions';

import './index.sass';

/* global document */
/* global window */

class HomeTemplate extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			invalidCard: false,
			cardCode: '',
			sendingPhoto: false,
			modalIsOpen: false,
			hasSale: false,
			secret: '',
			has2FA: false,
			facialModalIsOpen: false,
		};

		this.parseCard = this.parseCard.bind(this);
	}

	componentDidMount() {
		this.getCardFromUrl()
	}

	componentDidUpdate(prevProps) {
		const { sendingPhoto } = prevProps;
		if (sendingPhoto) return;

		const { cardCode } = this.state;
		const { media: mediaState } = this.props;
		const { soldMedias = [], notSoldMedias = [], error, loading } = mediaState;
		const { history } = this.props;

		if (!error && !loading && ((soldMedias && soldMedias.length > 0) || (notSoldMedias && notSoldMedias.length > 0))) {
			history.push('/gallery/' + cardCode);
		}

		if (this.cardInput && this.cardInput.input) {
			this.cardInput.input.focus();
		}

		this.checkToShowModal()
	}

	checkToShowModal = () => {
		const {media: mediaState} = this.props;
		const {error} = mediaState;
		const {organization: orgState} = this.props;
		const {organization = {}} = orgState;
		const {has_online_sale} = organization;
		const { two_factor_authentication: twoFactorAuthentication } = this.props.organization.features_organization || {};

		if (error === 'CARD_EMPTY_MEDIA') {
			if (has_online_sale){
				this.openModal(true)
			} else {
				this.openModal(false)
			}
		}

		if (error === 'CUSTOMER_CODE_NOT_FOUND' || error === 'CARD_NOT_FROM_CUSTOMER')
			if (twoFactorAuthentication){
				this.openModal(true)
			} else {
				this.openModal(false)
			}
	}

	getCardFromUrl = () => {
		const {history} = this.props;
		const search = new URLSearchParams(history.location.search);
		const card = search.get('card');
		const { two_factor_authentication: twoFactorAuthentication } = this.props.organization.features_organization || {};

		if (card && card.length === 9) {
			this.setState({
				cardCode: `${card.substring(0, 2)}-${card.substring(2, 6)}-${card.substring(6, 9)}`
			}, () => {
				if (!twoFactorAuthentication && !sessionStorage.getItem('firstLoad')) {
					sessionStorage.setItem('firstLoad', true)
					this.parseCard()
				}
			});
		}
	}

	setInvalidCard(status = false) {
		this.setState({
			invalidCard: status
		});
	}

	parseCard(e = null) {
		if (e) {
			e.preventDefault();
		}

		let {cardCode} = this.state;
		cardCode = cardCode.replace(/[-,_]/g, '').toUpperCase();

		const {organization: orgState} = this.props;
		const {organization = {}} = orgState;
		const {features_organization = {}} = organization;
		const {two_factor_authentication:twoFatorAuthentication} = features_organization || {};

		if (twoFatorAuthentication) {
			let {secret} = this.state;
			secret = secret.toUpperCase();

			if (secret.length < 6) {
				this.setInvalidCard(true);
				return;
			} else {
				this.setInvalidCard(false);
			}
		}

		if (cardCode.length < 9) {
			this.setInvalidCard(true);
		} else {
			this.setInvalidCard(false);
			this.readCard([cardCode])
		}
	}

	parseCards = (cards) => (typeof cards === 'string' ? [cards] : cards);

	// searchId: the selfie search the cards came from, sent back so the
	// cloud can tell which of its results were opened.
	readCard = (cards, searchId) => {
		cards = this.parseCards(cards)
		const { fetchMedias, clearMedias, organization: organizationState} = this.props;
		const { organization = {} } = organizationState || {};
		const { id } = organization || {};
		const { secret } = this.state;

		clearMedias();
		fetchMedias(cards, id, secret, searchId);
		this.setState({
			cardCode: cards[0],
			secret: secret
		});
		this.sendCardReadEvent();
	}

	sendCardReadEvent = () => {
		const {organization: orgState} = this.props;
		const {organization = {}} = orgState;
		const {name} = organization;

		Analytics.sendEvent('card_read', 'browsing', name);
	}

	searchCustomer = (customer) => {
		const {organization: orgState} = this.props;
		const {organization = {}} = orgState;
		const {id} = organization;
		const {fetchCardCustomer, clearMedias} = this.props;

		clearMedias();
		fetchCardCustomer(customer, id);
	}

	changeCardCode = (e) => {
		this.setState({
			cardCode: e.target.value,
			invalidCard: false
		});

		const {media: mediaState, clearMedias} = this.props;
		const {soldMedias, notSoldMedias, error} = mediaState;
		if ((soldMedias && notSoldMedias) || error) {
			clearMedias()
		}
	}

	changeSecret = (e) => {
		this.setState({
			secret: e.target.value
		});
	}

	openModal = (hasSale, has2FA) => {
		const {clearMedias} = this.props;
		this.setState({ modalIsOpen: true, hasSale, has2FA});
		clearMedias();
	};

	closeModal = () => {
		this.setState({ modalIsOpen: false });
	};

	openFacialModal = () => {
		this.setState({ facialModalIsOpen: true });
	};

	closeFacialModal = () => {
		this.setState({ facialModalIsOpen: false });
	};

	render() {
		const {media: mediaState} = this.props;
		const {soldMedias = [], notSoldMedias = [], error, loading} = mediaState;
		const {organization: orgState} = this.props;
		const {organization = {}} = orgState;
		const { 
			name, 
			web_name,
			external_help_url,
			external_help_id,
			contact_email,
			features = {},
			features_organization = {},
			has_facial_recognition: hasFacialRecognition = false,
			search_max_range: searchMaxRange = 1,
			can_send_photo: canSendPhoto = false} = organization;
			
		let readCardCode = organization.read_card_code != null ? organization.read_card_code : true;
		const {site = {}} = features || {};
		const { customer_form_fields: customerFormFields, cpf_as_password: cpfAsPassword} = site;
		const {webapp_initial_form: webappInitialForm} = features_organization || {};
		const {cardCode, invalidCard, sendingPhoto, secret} = this.state;
		const {two_factor_authentication:twoFatorAuthentication} = features_organization || {};
		const { config: organizationConfig } = features_organization || {};
		const {HOME_SITE_TITLE: homeSiteTitle, HOME_WITHOUT_PHOTO_CARD: homeWithoutPhotoCard} = organizationConfig || {};

		const {intl} = this.props;
		const {formatMessage} = intl;
		const emptyCard = soldMedias && soldMedias.length === 0 && notSoldMedias && notSoldMedias.length === 0;
		const messages = defineMessages({
			title: {
				id: 'home.title',
				defaultMessage: 'Veja aqui suas fotos mágicas!'
			},
			subtitle: {
				id: 'home.subtitle',
				defaultMessage: 'Digite o código do seu cartão-fotografia.'
			},
			subtitle_customer: {
				id: 'home.subtitle_customer',
				defaultMessage: 'Insira os dados conforme descrito abaixo.'
			},		
			subtitle_card: {
				id: 'home.subtitle_card',
				defaultMessage: 'Digite o código do seu cartão.'
			},
			subtitle_facialRecognition: {
				id: 'home.subtitle_facial',
				defaultMessage: 'Utilize o reconhecimento facial.'
			},
			subtitle_card_facialRecognition: {
				id: 'home.subtitle_card_facial',
				defaultMessage: 'Digite o código do seu cartão ou utilize o reconhecimento facial.'
			},
			warning: {
				id: 'home.footer.warning',
				defaultMessage: 'Suas fotos podem demorar até 48 horas para ficarem disponíveis.'
			},
			contact: {
				id: 'home.footer.contact',
				defaultMessage: 'Em caso de problemas, '
			},
			redirectContactEmail: {
				id: 'home.footer.contact.email',
				defaultMessage: 'envie um email para:'
			},
			redirectContact: {
				id: 'home.footer.contact.link',
				defaultMessage: 'clique aqui'
			},
			button: {
				id: 'home.button',
				defaultMessage: 'Carregar cartão'
			},
			customerButton: {
				id: 'home.customerButton',
				defaultMessage: 'Pesquisar cliente'
			},
			invalidCard: {
				id: 'home.card.invalid',
				defaultMessage: 'Cartão inválido'
			},
			cardNotFound: {
				id: 'home.card.notFound',
				defaultMessage: 'Cartão inválido'
			},
			cardEmptyPhoto: {
				id: 'home.card.emptyPhoto',
				defaultMessage: 'Não há fotos disponíveis para este cartão'
			},
			cardGenericError: {
				id: 'home.card.genericError',
				defaultMessage: 'Algo de errado aconteceu'
			},
			customerNotFound: {
				id: 'home.customer.notFound',
				defaultMessage: 'Cliente não encontrado'
			},
			sendPhotos: {
				id: 'home.sendPhotos',
				defaultMessage: 'Enviar fotos'
			},
			facialRecognition: {
				id: 'home.facialRecognition',
				defaultMessage: 'Enviar fotos'
			},
		});

		const getErrorMessage = (error) => {
			if (invalidCard) {
				return formatMessage(messages.invalidCard);
			}

			switch (error) {
			case 'CARD_NOT_FOUND':
				return formatMessage(messages.cardNotFound);
			case 'CARD_EMPTY_MEDIA':
				return formatMessage(messages.cardEmptyPhoto);
			case 'CUSTOMER_NOT_FOUND':
				return formatMessage(messages.customerNotFound);
			default:
				return formatMessage(messages.cardGenericError);
			}
		};

		const getButtonMessage = () => {
			if (invalidCard || error || emptyCard) {
				return getErrorMessage(error);
			}
			return formatMessage(messages.button);
		};

		const getButtonCustomerMessage = () => {
			if (error) {
				return getErrorMessage(error);
			}

			if (emptyCard) {
				return formatMessage(messages.cardEmptyPhoto);
			}

			return formatMessage(messages.customerButton);
		};
		const handleChangeLanguage = (value) => {
			const currentValue = LocalStorage.getItem('locale');

			if (currentValue !== value) {
				Analytics.sendEvent(`change_language_to_${value}`, 'browsing', name);
				LocalStorage.setItem('locale', value);
				document.location.reload(true);
			}
			if (this.cardInput && this.cardInput.input) {
				this.cardInput.input.focus();
			}
		};

		const getSubtitleHome = () => {
			if (hasFacialRecognition && readCardCode) {
				return formatMessage(messages.subtitle_card_facialRecognition);
			}
			if (hasFacialRecognition) {
				return formatMessage(messages.subtitle_facialRecognition);
			}
			return formatMessage(messages.subtitle_card);
		}

		const subtitleHome = getSubtitleHome()

		return (
			<div className="Home">
				<Helmet />
				<Background name={web_name} />
				<Grid type="container" justify="center">
					<Grid xl={3} lg={4} md={4} sm={8} xs={10}>
						<Logo className="Home__logo" name={web_name} />
						<Text className="Home__title" variant="h3" paragraph>
							{homeSiteTitle || formatMessage(messages.title)}
						</Text>
						{canSendPhoto && sendingPhoto ? (
							<SendPhotoForm
								onClose={(cardToShow) => {
									this.setState({
										sendingPhoto: false
									});

									if (cardToShow) this.readCard(cardToShow);
								}}
							/>
						) : (
							<div>
								{webappInitialForm && webappInitialForm === 'customer' ? (
									<>
										<Text className="Home__subtitle" variant="subtitle1" paragraph>
											{formatMessage(messages.subtitle_customer)}
										</Text>
										<GetCustomerForm
											fields={customerFormFields}
											cpfAsPassword={cpfAsPassword}
											loading={loading}
											buttonMessage={getButtonCustomerMessage()}
											hasError={Boolean(invalidCard || error || emptyCard)}
											onSubmit={this.searchCustomer}
										/>
									</>
								) : (
									<>
										<Text className="Home__subtitle" variant="subtitle1" paragraph>
											{subtitleHome}
										</Text>
										{readCardCode &&
											<>
												<CardForm
													cardCode={cardCode}
													secret={secret}
													loading={loading}
													buttonMessage={getButtonMessage()}
													hasError={Boolean(invalidCard || error)}
													onChange={this.changeCardCode}
													onChangeSecret={this.changeSecret}
													onSubmit={this.parseCard}
													show2FA={twoFatorAuthentication}
												>
												</CardForm>
											</>
										}
										{canSendPhoto && (
											<Button
												className="Home__button"
												color='quaternary'
												onClick={() => {
													this.setState({
														sendingPhoto: true
													})
												}}
											>
												{formatMessage(messages.sendPhotos)}
											</Button>
										)}
										{hasFacialRecognition && (
											<div className="Home__facialRecognition">												
												<Button
													className="Home__facialRecognition__button"
													color="secondary"
													size="medium"
													onClick={this.openFacialModal}
												>
													<img src={FacialIcon} alt="Facial Recognition" className="Home__facialRecognition__button__icon" />
												</Button>
											</div>
										)}
									</>
								)}
							</div>
						)}
						<Text className="Home__footer Home__footer--main" variant="caption">
							{formatMessage(messages.warning)}
						</Text>
						<Text className="Home__footer" variant="caption" paragraph>
							{`${formatMessage(messages.contact)} `}
							{
								external_help_url ? (
									<Link href={`${external_help_url}?qrcode=${cardCode}&empresa=${external_help_id}`} >
										{formatMessage(messages.redirectContact)}
									</Link>
								) : (
									<>
										{formatMessage(messages.redirectContactEmail)}
										<Link
											href={contact_email || 'contato@roverpix.com'}
											subject='Ajuda para ver minhas fotos digitais'
											body={`Código do cartão: ${cardCode}`}
										/>
									</>
								)
							}

						</Text>
						<LanguageChooser
							onChange={handleChangeLanguage}
						/>
					</Grid>
					{(!webappInitialForm || webappInitialForm !== 'customer') && !homeWithoutPhotoCard && (
						<Grid lg={4} md={4} sm={10} xs={10}>
							<div className="center">
								<Card
									className="Home__card"
									url={window.location.host}
								/>
							</div>
						</Grid>
					)}
				</Grid>
				<ErrorModal open={this.state.modalIsOpen} onClose={this.closeModal} hasSale={this.state.hasSale} showError2FA={this.state.has2FA}/>
				<FacialModal onCardsSelected={this.readCard} open={this.state.facialModalIsOpen} onClose={this.closeFacialModal} organizationId={organization.id} searchMaxRange={searchMaxRange} />
			</div>
		);
	}
}

HomeTemplate.propTypes = {
	intl: PropTypes.object.isRequired,
	card: PropTypes.shape({
		card: PropTypes.shape({
			id: PropTypes.string
		}),
		photo_count: PropTypes.number
	}),
	organization: PropTypes.shape({
		organization: PropTypes.shape({
			name: PropTypes.string,
			web_name: PropTypes.string,
			url: PropTypes.string,
			contact_email: PropTypes.string,
			two_factor_authentication: PropTypes.bool
		}),
		loading: PropTypes.bool,
		error: PropTypes.string,
		secret: PropTypes.string,
	}).isRequired,
	history: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
	card: state.card,
	media: state.media,
	organization: state.organization,
	secret: state.secret,
});

const mapActionsToProps = dispatch => ({
	fetchMedias: (cardCode, organizationId, secret, searchId) => dispatch(fetchMedias(cardCode, organizationId, secret, searchId)),
	fetchCard: (cardCode,organizationId) => dispatch(fetchCard(cardCode, organizationId)),
	fetchCardCustomer: (customer, organization_id) => dispatch(fetchCardCustomer(customer, organization_id)),
	clearMedias: () => dispatch(clearMedias()),
	clearCard: () => dispatch(clearCard()),
});

export default withRouter(connect(mapStateToProps, mapActionsToProps)(injectIntl(HomeTemplate)));
